import axios from "axios";
import { message } from "antd";
import { Upload} from "antd";
import { Method_POST } from "./api";
import { toast } from "react-toastify";
import jsPDF from "jspdf";

const BASE_URL = "/portal/rest/contador";
const BASE_URL_CERTIFICADO = "/portal/rest/contador/empresa/credencial-acesso";

const BASE_URL_CLIENTE = "/portal/rest/cliente/arquivo";

export const fetchListDocumento = async (numeroSolicitacao) => {
  try {
    const url = `/ordem-servico/documento/listar`;
    const data = { id: numeroSolicitacao };

    const responseData = await Method_POST(url, data);
    if (!responseData || !responseData.files) {
      throw new Error("Nenhum dado retornado da API");
    }

    return responseData.files; // Retorna a lista de arquivos
  } catch (error) {
    console.error("Erro ao buscar documentos:", error.message);
    throw error;
  }
};

//converter imagem em pdf
async function convertImageToPDF(file) {
  const reader = new FileReader();

  const result = await new Promise((resolve, reject) => {
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const imgProps = pdf.getImageProperties(result);
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

  pdf.addImage(result, file.type === "image/png" ? "PNG" : "JPEG", 0, 0, pdfWidth, pdfHeight);

  const pdfBlob = pdf.output("blob");

  return new File(
    [pdfBlob],
    `${Date.now()}-${file.name.replace(/\.(png|jpg|jpeg)$/i, ".pdf")}`,
    { type: "application/pdf" }
  );
}

export const uploadDocumentoProps = (config, endpoint, onUploadSuccess) => {
  const customRequest = async ({ file, onSuccess, onError }) => {
    try {
      let fileToUpload;

      // Converte imagem se necessário
      if (file.type === "image/png" || file.type === "image/jpeg") {
        fileToUpload = await convertImageToPDF(file);
      } else {
        fileToUpload = new File([file], `${Date.now()}-${file.name}`, {
          type: file.type,
        });
      }

      const formData = new FormData();
      formData.append("file", fileToUpload);
      formData.append("path", `ordem-${config}`);
      formData.append("filePrefix", "");
      formData.append("fileCategory", "DOCUMENTO_EMPRESA");

      const response = await axios.post(`${BASE_URL}${endpoint}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 200 || response.status === 204) {
        toast.success(`Arquivo carregado com sucesso!`);
        onSuccess("ok");

        if (onUploadSuccess) onUploadSuccess();
      }
    } catch (error) {
      const errorMsg =
        error.response?.status === 403
          ? "Erro 403 - Acesso negado"
          : error.response?.status === 500
          ? "Erro 500 - Erro no servidor"
          : "Erro desconhecido";

      toast.error(`${file.name} falha no upload: ${errorMsg}`);
      onError(error);
    }
  };

  return {
    name: "file",
    multiple: true,
    customRequest,
    onChange(info) {
      if (info.file.status === "done") {
        console.log(`${info.file.name} enviado com sucesso.`);
      } else if (info.file.status === "error") {
        toast.error(`${info.file.name} falhou no envio.`);
      }
    },
  };
};

export async function uploadFile(config, endpoint, file, onUploadSuccess) {
  try {
    let fileToUpload;

    if (file.type === "image/png" || file.type === "image/jpeg") {
      fileToUpload = await convertImageToPDF(file);
    } else {
      fileToUpload = new File([file], `${Date.now()}-${file.name}`, {
        type: file.type,
      });
    }

    const formData = new FormData();
    formData.append("file", fileToUpload);

    const response = await axios.post(`${BASE_URL_CLIENTE}${endpoint}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (response.status === 200 || response.status === 204) {
      toast.success(`Arquivo carregado com sucesso!`);
      if (onUploadSuccess) onUploadSuccess();
    }

    return response;
  } catch (error) {
    const errorMsg =
      error.response?.status === 403
        ? "Erro 403 - Acesso negado"
        : error.response?.status === 500
        ? "Erro 500 - Erro no servidor"
        : "Erro desconhecido";

    toast.error(`${file.name} falha no upload: ${errorMsg}`);
    throw error;
  }
}

export const UploadDocumentoClientContextProps = (config, endpoint, onUploadSuccess) => ({
  name: "file",
  multiple: false,
  customRequest: async ({ file, onSuccess, onError }) => {
    try {
      await uploadFile(config, endpoint, file, onUploadSuccess);
      onSuccess("ok"); // ✅ notifica o AntD que finalizou
    } catch (error) {
      onError(error); // ❌ notifica erro
    }
  },
  onChange(info) {
    if (info.file.status === "done") {
      console.log(`${info.file.name} enviado com sucesso.`);
    } else if (info.file.status === "error") {
      console.error(`${info.file.name} falhou no envio.`);
    }
  },
});

export const uploadCertificado = (clienteId, osId) => {
  const customRequest = async ({ file, onSuccess, onError }) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("filePrefix", "certificado-digital");
    formData.append("clienteId", clienteId);
    formData.append("osId", osId);

    try {
      const response = await axios.post(`${BASE_URL_CERTIFICADO}/certificado/arquivo/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200 || response.status === 204) {
        message.success(`${file.name} carregado com sucesso`);
        onSuccess("ok");
      }
    } catch (error) {
      if (error.response) {
        const { id, mensagem } = error.response.data.erro || {};
        if (id === "TE-0001") {
          message.error(mensagem || "Erro ao processar o certificado. Por favor, tente novamente.");
        } else {
          switch (error.response.status) {
            case 403:
              message.error("Erro 403 - Acesso negado");
              break;
            case 500:
              message.error("Erro 500 - Erro no servidor");
              break;
            default:
              message.error("Erro desconhecido");
          }
        }
      } else {
        message.error(`${file.name} falha no upload`);
      }
      onError(error);
    }
  };

  return {
    name: "file",
    multiple: false,
    customRequest,
    beforeUpload: async (file) => {
      const isP12 = file.type === "application/p12";
      if (!isP12) {
        message.error("Você pode apenas fazer upload de arquivos p12!");
        return Upload.LIST_IGNORE;
      }

      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        message.error("O arquivo deve ser menor que 5MB!");
        return Upload.LIST_IGNORE;
      }
      return true;
    },
    onChange(info) {
      if (info.file.status === "done") {
        message.success(`${info.file.name} arquivo enviado com sucesso.`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} falha no upload do arquivo.`);
      }
    },
  };
};

